import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/dashboard");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="font-body min-h-[80vh] grid place-items-center px-5 py-16 bg-[#f8faf9]">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <span className="grid place-items-center w-14 h-14 rounded-full bg-[#0B5D3B] text-white mx-auto"><Lock size={24}/></span>
          <h1 className="font-heading text-2xl font-bold text-gray-900 mt-4">Owner Login</h1>
          <p className="text-sm text-gray-500 mt-1">Access your CRM dashboard</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl shadow-[0_12px_40px_rgba(11,93,59,0.1)] p-8 space-y-4" data-testid="login-form">
          <input data-testid="login-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="Email" className="w-full rounded-lg border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#0B5D3B]"/>
          <input data-testid="login-password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="Password" className="w-full rounded-lg border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#0B5D3B]"/>
          <button data-testid="login-submit" disabled={busy} className="w-full rounded-full bg-[#0B5D3B] text-white py-3.5 font-semibold hover:bg-[#094e32] transition-colors disabled:opacity-60">{busy?"Signing in…":"Sign In"}</button>
        </form>
        <Link to="/" className="block text-center text-sm text-gray-500 mt-6 hover:text-[#0B5D3B]">← Back to website</Link>
      </div>
    </div>
  );
}
